import { Component, HostBinding, OnInit } from '@angular/core';
// import { MonitoringService } from './shared/services/monitoring/monitoring.service';
import { detect } from 'detect-browser';
import { FuseSplashScreenService } from '@fuse/services/splash-screen.service';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import {
  Event as RouterEvent,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router,
} from '@angular/router';
import { BreakpointObserver } from '@angular/cdk/layout';
import { AuthService } from './shared/services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  @HostBinding('@.disabled')
  public animationsDisabled = false; // = true to disable animations
  // See https://angular.io/api/animations/trigger#disable-animations
  // See https://blog.angularindepth.com/total-guide-to-dynamic-angular-animations-that-can-be-toggled-at-runtime-be5bb6778a0a

  public isShowingRouteLoadIndicator: boolean;
  public isMobile: boolean;

  constructor(
    private fuseNavigationService: FuseNavigationService, // This line is required to make app start correctly. it is a side effect
    private fuseSplashScreen: FuseSplashScreenService, // This line is required to make app start correctly. it is a side effect
    private router: Router,
    private auth:AuthService,
    private observer: BreakpointObserver // MRD - create an instance of the monitoring instance as soon as the app starts... // private monitoringService: MonitoringService,
  ) {
    const browser = detect();
    if (browser && browser.name === 'ie') {
      this.animationsDisabled = true;
    }

    // Add loading UI when lazy loading modules from server.
    // https://www.bennadel.com/blog/3505-showing-a-loading-indicator-for-lazy-loaded-route-modules-in-angular-6-1-7.htm
    // https://www.bennadel.com/blog/3506-preloading-lazy-loaded-feature-modules-in-angular-6-1-9.htm
    this.isShowingRouteLoadIndicator = false;
    this.isMobile = this.observer.isMatched('(max-width: 600px)');

    // *************************************************************************** //
    // CAUTION: Even though we are preloading our lazy-loading modules with the
    // "PreloadAllModules" configuration, the following Router events still fire
    // when the RouterPreloader's requests for the remote code are initiated and
    // completed, respectively. As such, this code is still relevant. And, on a
    // slower connection, may still show the loading indicator shortly after the
    // application has been bootstrapped (depending on what the initial URL of
    // the application is).
    // *************************************************************************** //

    // As the router loads modules asynchronously (via loadChildren), we're going to
    // keep track of how many asynchronous requests are currently active. If there is
    // at least one pending load request, we'll show the indicator.
    let asyncLoadCount = 0;

    // As the user navigates around the application, we're going to keep track of how
    // many pending navigation requests are currently active. This way, we can know
    // if the asynchronous module loading is [possibly] happening because of a user
    // navigation; or, if it's happening as part of the pre-loading.
    let navigationCount = 0;

    // The Router emits special events for "loadChildren" configuration loading. We
    // just need to listen for the Start and End events, amidst the rest of the
    // events, in order to determine if we have any pending configuration requests.
    router.events.subscribe((event: RouterEvent): void => {
      if (event instanceof RouteConfigLoadStart) {
        asyncLoadCount++;
      } else if (event instanceof RouteConfigLoadEnd) {
        asyncLoadCount--;
      } else if (event instanceof NavigationStart) {
        navigationCount++;
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationError ||
        event instanceof NavigationCancel
      ) {
        navigationCount--;
      }

      // If there is at least one pending asynchronous config load request AND
      // it is taking place while a the user is actively navigating around the
      // application, then let's show the loading indicator. This way, we don't
      // show the loading indicator during the preloading of lazy modules. This
      // isn't an exact science, since the navigation may not be tied to the
      // config load request. But, the small delay in rendering the indicator
      // should make the fuzzy-association a non-issue (as unrelated navigation
      // events will start and end almost instantly).
      // --
      // CAUTION: I'm using CSS to include a small delay such that this loading
      // indicator won't be seen by people with sufficiently fast connections.
      this.isShowingRouteLoadIndicator = !!(navigationCount && asyncLoadCount);
    });    
  }
  
  logOut() {
    this.auth.logout();    
  }
}
